var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "处理",
            visible: _vm.processDialogVisible,
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.processDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "processForm",
              attrs: {
                model: _vm.processForm,
                rules: _vm.processRules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "处理结果：", prop: "status" },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.processForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.processForm, "status", $$v)
                        },
                        expression: "processForm.status",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: 1 } }, [
                        _vm._v("装修已完成"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "说明：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: 300,
                      "show-word-limit": "",
                      placeholder: "请输入...",
                    },
                    model: {
                      value: _vm.processForm.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.processForm, "remarks", $$v)
                      },
                      expression: "processForm.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.processDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitProcess },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传标书",
            visible: _vm.biddingDialogVisible,
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.biddingDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "biddingForm",
              attrs: {
                model: _vm.biddingForm,
                rules: _vm.biddingRules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "投标文件", prop: "bid_files" } },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "500px" } },
                    [
                      _c("uploadFile", {
                        ref: "bidFileUpload",
                        attrs: {
                          "file-list": _vm.biddingForm.bid_files,
                          limit: 9,
                          multiple: true,
                          "current-file-count":
                            _vm.biddingForm.bid_files.length,
                          source: "file",
                          "only-img": false,
                          "link-url": {
                            config: "/user/project-delivery-file/upload/config",
                            extensions:
                              "/user/project-delivery-file/upload/file-allow-extensions",
                          },
                        },
                        on: { emitUploadFile: _vm.handleBiddingFileUploaded },
                      }),
                    ],
                    1
                  ),
                  _vm.biddingForm.bid_files.length
                    ? _c(
                        "div",
                        { staticClass: "file-list bid-file-list" },
                        _vm._l(_vm.biddingForm.bid_files, function (item, idx) {
                          return _c(
                            "div",
                            { key: idx, staticClass: "bid-file-item" },
                            [
                              _vm.isBiddingFileImage(item)
                                ? [
                                    _c("el-image", {
                                      staticClass: "bid-file-img",
                                      attrs: {
                                        src: _vm.$ossurl + item.url,
                                        fit: "contain",
                                        "preview-src-list":
                                          _vm.biddingImageSrcList,
                                      },
                                    }),
                                  ]
                                : _c(
                                    "span",
                                    {
                                      staticClass: "bid-file-name",
                                      class: {
                                        "pdf-file":
                                          _vm.cardAndCouponDesignIsPdf(item),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.cardAndCouponDesignIsPdf(item) &&
                                            _vm.cardAndCouponDesignOpenFile(
                                              item
                                            )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item.file_name))]
                                  ),
                              _c("el-button", {
                                attrs: { type: "text", icon: "el-icon-delete" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteBiddingFile(idx)
                                  },
                                },
                              }),
                              _c("el-button", {
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-download",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.downBiddingFile(
                                      item.url,
                                      item.file_name
                                    )
                                  },
                                },
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否检查", prop: "is_check" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.biddingForm.is_check,
                        callback: function ($$v) {
                          _vm.$set(_vm.biddingForm, "is_check", $$v)
                        },
                        expression: "biddingForm.is_check",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                      _c("el-radio", { attrs: { label: "2" } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.biddingForm.is_check === "1"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "检查人", prop: "check_person_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            remote: "",
                            "remote-method": _vm.searchCheckPerson,
                            loading: _vm.personLoading,
                            "no-data-text": "无数据",
                            placeholder: "请选择",
                          },
                          on: {
                            change: _vm.handleCheckPersonChange,
                            clear: _vm.handleCheckPersonClear,
                          },
                          model: {
                            value: _vm.biddingForm.check_person_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.biddingForm, "check_person_id", $$v)
                            },
                            expression: "biddingForm.check_person_id",
                          },
                        },
                        _vm._l(
                          _vm.personOptions.checkPerson || [],
                          function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label:
                                  (item.name ||
                                    item.nick_name ||
                                    String(item.id)) +
                                  (item.status_cn && item.status_cn !== "在职"
                                    ? "（" + item.status_cn + "）"
                                    : ""),
                                value: item.id,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "说明" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入",
                      maxlength: 2000,
                    },
                    model: {
                      value: _vm.biddingForm.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.biddingForm, "remarks", $$v)
                      },
                      expression: "biddingForm.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.biddingDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitBiddingProcess },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "项目处理",
            visible: _vm.projectDialogVisible,
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.projectDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "projectForm",
              attrs: {
                model: _vm.projectForm,
                rules: _vm.projectRules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "bid_status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.projectForm.bid_status,
                        callback: function ($$v) {
                          _vm.$set(_vm.projectForm, "bid_status", $$v)
                        },
                        expression: "projectForm.bid_status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("项目已完成"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("弃标"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.projectForm.bid_status === "2"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "弃标原因" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入弃标原因",
                          maxlength: 2000,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.projectForm.abandon_reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.projectForm, "abandon_reason", $$v)
                          },
                          expression: "projectForm.abandon_reason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.projectForm.bid_status != "2"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入",
                          maxlength: 300,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.projectForm.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.projectForm, "remarks", $$v)
                          },
                          expression: "projectForm.remarks",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.projectDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitProjectProcess },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "定制设计印刷处理",
            visible: _vm.cardAndCouponDesignDialogVisible,
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cardAndCouponDesignDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "cardAndCouponDesignForm",
              attrs: {
                model: _vm.cardAndCouponDesignForm,
                rules: _vm.cardAndCouponDesignRules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设计复杂度：", prop: "design_complexity" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.cardAndCouponDesignForm.design_complexity,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cardAndCouponDesignForm,
                            "design_complexity",
                            $$v
                          )
                        },
                        expression: "cardAndCouponDesignForm.design_complexity",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("简单")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("中级")]),
                      _c("el-radio", { attrs: { label: 3 } }, [_vm._v("复杂")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "设计稿：", prop: "design_img" } },
                [
                  _c(
                    "span",
                    { on: { paste: _vm.handleCardAndCouponDesignPaste } },
                    [
                      _c("input", {
                        staticClass: "pasteInput",
                        attrs: {
                          type: "text",
                          placeholder: "粘贴截图上传",
                          maxlength: "0",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "el-icon-upload importFile",
                      attrs: {
                        type: "primary",
                        disabled:
                          _vm.cardAndCouponDesignForm.design_img &&
                          _vm.cardAndCouponDesignForm.design_img.length >= 9,
                      },
                      on: { click: _vm.cardAndCouponDesignUploadFile },
                    },
                    [
                      _vm._v(
                        "上传设计稿 (" +
                          _vm._s(
                            _vm.cardAndCouponDesignForm.design_img
                              ? _vm.cardAndCouponDesignForm.design_img.length
                              : 0
                          ) +
                          "/9)"
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { color: "#909399", "margin-top": "5px" } },
                    [
                      _vm._v(
                        " 设计稿支持上传JPGE、JPG、PNG、PSD、PDF、ai 格式的文件 "
                      ),
                    ]
                  ),
                  _c("div", { staticStyle: { position: "relative" } }, [
                    _vm.cardAndCouponDesignForm.design_img.some(function (
                      item
                    ) {
                      return _vm.cardAndCouponDesignIsImage(item)
                    })
                      ? _c(
                          "div",
                          { staticClass: "img-style2" },
                          _vm._l(
                            _vm.cardAndCouponDesignForm.design_img.filter(
                              function (el) {
                                return _vm.cardAndCouponDesignIsImage(el)
                              }
                            ),
                            function (item, indexs) {
                              return _c(
                                "div",
                                {
                                  key: "img-" + indexs,
                                  staticClass: "img-style2-con",
                                },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      height: "50px",
                                      width: "70px",
                                    },
                                    attrs: {
                                      src: _vm.$ossurl + item.url,
                                      fit: "contain",
                                      "preview-src-list":
                                        _vm.cardAndCouponDesignForm.design_img
                                          .filter(function (el) {
                                            return _vm.cardAndCouponDesignIsImage(
                                              el
                                            )
                                          })
                                          .map(function (el) {
                                            return _vm.$ossurl + el.url
                                          }),
                                    },
                                  }),
                                  _c("i", {
                                    staticClass: "el-icon-circle-close close",
                                    on: {
                                      click: function ($event) {
                                        _vm.cardAndCouponDesignDelStyleImage(
                                          _vm.cardAndCouponDesignGetOriginalIndex(
                                            item
                                          )
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm.cardAndCouponDesignForm.design_img.some(function (
                      item
                    ) {
                      return !_vm.cardAndCouponDesignIsImage(item)
                    })
                      ? _c(
                          "div",
                          { staticClass: "file-list" },
                          _vm._l(
                            _vm.cardAndCouponDesignForm.design_img.filter(
                              function (el) {
                                return !_vm.cardAndCouponDesignIsImage(el)
                              }
                            ),
                            function (item, indexs) {
                              return _c(
                                "div",
                                {
                                  key: "file-" + indexs,
                                  staticClass: "file-item",
                                },
                                [
                                  _c("div", { staticClass: "file-info" }, [
                                    _c("i", {
                                      staticClass: "el-icon-document file-icon",
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "file-name",
                                        class: {
                                          "pdf-file":
                                            _vm.cardAndCouponDesignIsPdf(item),
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.cardAndCouponDesignIsPdf(
                                              item
                                            ) &&
                                              _vm.cardAndCouponDesignOpenFile(
                                                item
                                              )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.file_name))]
                                    ),
                                  ]),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-circle-close file-close",
                                    on: {
                                      click: function ($event) {
                                        _vm.cardAndCouponDesignDelStyleImage(
                                          _vm.cardAndCouponDesignGetOriginalIndex(
                                            item
                                          )
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                  _c("uploadFile", {
                    ref: "cardAndCouponDesignUploadBanner",
                    staticStyle: { display: "none" },
                    attrs: {
                      "only-img": false,
                      "link-url": {
                        config: "/user/project-delivery-file/upload/config",
                        extensions:
                          "/user/project-delivery-file/upload/file-allow-extensions",
                      },
                      limit: 9,
                      multiple: true,
                    },
                    on: {
                      emitUploadFile: _vm.cardAndCouponDesignEmitUploadFile,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: 300,
                      "show-word-limit": "",
                      placeholder: "请输入...",
                    },
                    model: {
                      value: _vm.cardAndCouponDesignForm.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.cardAndCouponDesignForm, "remarks", $$v)
                      },
                      expression: "cardAndCouponDesignForm.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.cardAndCouponDesignDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitCardAndCouponDesign },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }